import { useState } from 'react';
import { useAppStore } from '../store/appStore';
import './TimeOverlay.css';

// YouTube Kids "Time's Up" calming video
const TIMES_UP_VIDEO_ID = '0gODSEsje38';

export function TimeOverlay() {
    const [showParentModal, setShowParentModal] = useState(false);
    const [pin, setPin] = useState('');
    const [error, setError] = useState('');
    const [isPinVerified, setIsPinVerified] = useState(false);
    const { unlockWithPin, extendSession, resetSession } = useAppStore();

    const handleVerifyPin = async () => {
        const success = await unlockWithPin(pin);
        if (success) {
            setIsPinVerified(true);
            setError('');
        } else {
            setError('Incorrect PIN');
        }
    };

    const handleExtend = (minutes: number) => {
        extendSession(minutes);
        handleCloseModal();
    };

    const handleNewSession = () => {
        resetSession();
        handleCloseModal();
    };

    const handleCloseModal = () => {
        setShowParentModal(false);
        setIsPinVerified(false);
        setPin('');
        setError('');
    };

    return (
        <div className="time-overlay">
            {/* Fullscreen calming video. It is intentionally inert while time is locked. */}
            <div
                className="time-overlay__video-wrapper"
                aria-hidden="true"
                style={{ position: 'absolute', inset: 0 }}
            >
                <iframe
                    className="time-overlay__video"
                    src={`https://www.youtube-nocookie.com/embed/${TIMES_UP_VIDEO_ID}?autoplay=1&mute=1&loop=1&controls=0&playlist=${TIMES_UP_VIDEO_ID}&modestbranding=1&showinfo=0`}
                    title="Time's Up"
                    frameBorder="0"
                    allow="autoplay"
                    style={{ pointerEvents: 'none' }}
                />
            </div>

            {/* Minimal bottom bar - just text and settings icon */}
            <div className="time-overlay__bottom">
                <span className="time-overlay__text">Süre doldu!</span>
                <button
                    type="button"
                    aria-label="Parent settings"
                    className="time-overlay__settings-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        setShowParentModal(true);
                    }}
                >
                    ⚙️
                </button>
            </div>

            {/* Parent modal (only when settings clicked) */}
            {showParentModal && (
                <div className="time-overlay__modal-backdrop" onClick={handleCloseModal}>
                    <div className="time-overlay__modal" onClick={e => e.stopPropagation()}>
                        <h3>Parent PIN</h3>
                        <input
                            type="password"
                            inputMode="numeric"
                            maxLength={6}
                            value={pin}
                            onChange={(e) => { setPin(e.target.value.replace(/\D/g, '')); setError(''); }}
                            placeholder="Enter PIN"
                            autoFocus
                            className="time-overlay__pin"
                            disabled={isPinVerified}
                        />
                        {error && <p className="time-overlay__error">{error}</p>}

                        {!isPinVerified && pin.length >= 4 && (
                            <div className="time-overlay__actions">
                                <button onClick={handleVerifyPin}>Unlock</button>
                            </div>
                        )}

                        {isPinVerified && (
                            <div className="time-overlay__actions">
                                <button onClick={() => handleExtend(15)}>+15 min</button>
                                <button onClick={() => handleExtend(30)}>+30 min</button>
                                <button onClick={handleNewSession}>New Session</button>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}
